// DS: MO3.4.5
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import BuyButton from '@wix/da-ds/pkg/Buttons/BuyButton';
import DeviationShopCard, {
  type DeviationShopCardProps,
} from '@wix/da-shared-react/pkg/ShopCard/DeviationShopCard';

interface Props extends Omit<DeviationShopCardProps, 'detailsRightSlot'> {}

const SellPromotionCard: React.FC<Props> = ({ deviation, ...rest }) => {
  const { t } = useTranslation();
  return (
    <DeviationShopCard
      deviation={deviation}
      detailsRightSlot={
        <BuyButton
          size="large"
          rounded
          href={Url.deviationLink(deviation.deviationId)}
        >
          {t(
            'shopPage.sellYourArt.strips.recommendedSellStrip.sellButton.label'
          )}
        </BuyButton>
      }
      {...rest}
    />
  );
};

SellPromotionCard.displayName = 'SellPromotionCard';

export default SellPromotionCard;
